import { component } from "picoapp";
import { debounce } from "../lib/utils";

export default component((node, ctx) => {
  const emitDebouncedResize = debounce(function () {
    ctx.emit("window:resize");
  }, 250);

  window.addEventListener("resize", () => emitDebouncedResize());
});
